export enum HeaderTitle {
    DashboardTitle = "New Hire Worksheet",
    GroupDetails = "Group Details",
    PlansSelection = "Plans Selection",
    Contribution = "Contribution",
    Delivery = "Delivery"    
}